module.exports = __webpack_public_path__ + "static/media/picpay-logo.f9240c29.png";